import React, { useRef } from 'react';

import { Button, Form, InputGroup } from 'react-bootstrap';

import noop from '../../utils/noop';

const UploadFileInput = ({
    id, inputId, value, label, onInputChange = noop, onFileSelect = noop, readOnly, disabled,
}) => {
    const ref = useRef(null);

    const handleClickButton = () => {
        if (ref) {
            ref.current.click();
        }
    };

    return (
        <div>
            {label ? <Form.Label><b>{label}</b></Form.Label> : null}
            <InputGroup>
                <Form.Control
                    id={id}
                    value={value}
                    onChange={onInputChange}
                    readOnly={readOnly}
                    onClick={readOnly ? handleClickButton : noop}
                    disabled={disabled}
                />
                <InputGroup.Append addontType="append">
                    <input id={inputId} type="file" onChange={onFileSelect} ref={ref} style={{ display: 'none' }} />
                    <Button
                        variant="outline-dark"
                        onClick={handleClickButton}
                        disabled={disabled}
                    >
                        Загрузить
                    </Button>
                </InputGroup.Append>
            </InputGroup>
        </div>
    );
};

export default UploadFileInput;
